/* src/messages/cards/MessageListCard/index.js */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';
import { createSelector } from 'reselect';
import { isEmpty, get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Avatar, Card, Typography } from '@material-ui/core';

// import { formatDate } from '../../../util';
import styles from './styles';

import { fetchCustomerSupportPools, selectSupportPoolUser, fetchMessages, setLastMessages } from '../../actions';
import { getLastMessages, saveLastMessages } from '../../../../config/localstore';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = 'message';

class MessageListCard extends React.Component {
  constructor(props) {
    super(props);
    this._handleChange = this._handleChange.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this.texts = loadTexts(TEXT_KEY, props.locale);
  }

  async componentDidMount() {
    const lastMessages = await getLastMessages();
    this.props.setLastMessages(lastMessages || {});
    await this.props.fetchCustomerSupportPools();
    if (!isEmpty(this.props.supportPoolKeyOrder)) {
      const id = this.props.supportPoolKeyOrder[0];
      this.props.selectSupportPoolUser(id);
      this.props.fetchMessages({ supportPool: id, page: { limit: -1 } });
    }
  }

  _save = async _id => {
    const updatedLastMessages = {
      ...this.props.lastMessages,
      [_id]: get(this, `props.supportPools.${_id}.lastMessage.0._id`),
    }
    this.props.setLastMessages(updatedLastMessages);
    saveLastMessages(updatedLastMessages);
  };

  _handleChange(event, value) {
    this.setState({ value, selected: null });
  }

  async _onSelect(_id) {
    this.props.selectSupportPoolUser(_id);
    // fetch all messages
    await this.props.fetchMessages({ supportPool: _id, page: { limit: -1 } });
    this._save(_id);
  }

  renderMessageSummary(classes, { _id, user: { avatar, first, last }, lastMessage, state, _seen }) {
    const ts = parseInt(get(lastMessage[0], 'createdAt.timestamp') || 0);
    const b = get(lastMessage[0], 'body') || '';
    const type = get(lastMessage[0], 'attachment.type') || 'image';
    return (
      <div
        className={classNames(
          classes.summaryContainer,
          {
            [classes.selected]: _id === this.props.selected,
            [classes.unread]: !_seen,
          }
        )}
        onClick={() => this._onSelect(_id)}
        role="option"
        aria-selected={_id === this.props.selected}
      >
        <Avatar
          alt={`${first} ${last}`}
          src={avatar}
          className={classes.avatar}
        >
          {!avatar && `${first[0]}${last[0]}`.toUpperCase()}
        </Avatar>
        <div className={classes.textContainer}>
          <div className={classes.nameTimeContainer}>
            <Typography variant="body2">{`${first} ${last}`}</Typography>
            <div className={classes.withStatus}>
              <Typography variant="body2">{moment(ts).format('MMM D, YYYY HH:mm')}</Typography>
              {state === 'PENDING' && (
                <Typography variant="body2" color="textSecondary">
                  {this.texts.status.pending}
                </Typography>
              )}
              {state === 'RESOLVED' && (
                <Typography variant="body2" color="textSecondary">
                  {this.texts.status.resolved}
                </Typography>
              )}
            </div>
          </div>
          <Typography color="textSecondary" noWrap className={classes.messagePreview}>
            {b || (get(lastMessage[0], 'attachment.payload') ? `${this.texts.fields.attachment}: ${type.toLowerCase()}` : this.texts.fields.none)}
          </Typography>
        </div>
      </div>
    );
  }

  render() {
    const { classes, supportPools, supportPoolKeyOrder } = this.props;
    if (isEmpty(supportPoolKeyOrder)) {
      return (
        <Card className={classes.card}>
          <div className={classes.none}>
            <Typography>
              {this.texts.status.no_users}
            </Typography>
          </div>
        </Card>
      );
    }
    return (
      <Card className={classes.card}>
        {supportPoolKeyOrder.map(key => (
          <React.Fragment key={key}>
            {this.renderMessageSummary(classes, supportPools[key])}
          </React.Fragment>
        ))}
      </Card>
    );
  }
}

MessageListCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  supportPools: createSelector(
    state => state.messages.main.data,
    state => state.messages.lastMessages,
    (data, lastMessages) => Object.values(data).reduce((acc, datum) => {
      return {
        ...acc,
        [datum._id]: {
          ...datum,
          _seen: lastMessages[datum._id] === get(datum, 'lastMessage.0._id'),
        },
      };
    }, {})
  )(state),
  supportPoolKeyOrder: createSelector(
    state => state.messages.main.data,
    supportPools => {
      const keys = Object.keys(supportPools);
      keys.sort((a, b) => {
        const supportPoolA = supportPools[a];
        const supportPoolB = supportPools[b];
        return parseInt(get(supportPoolB, 'lastMessage.0.createdAt.timestamp') || 0, 10)
          - parseInt(get(supportPoolA, 'lastMessage.0.createdAt.timestamp') || 0, 10);
      });
      return keys;
    }
  )(state),
  selected: state.messages.selected.selected,
  lastMessages: state.messages.lastMessages,
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchCustomerSupportPools: params => dispatch(fetchCustomerSupportPools(params)()),
  selectSupportPoolUser: params => dispatch(selectSupportPoolUser(params)),
  fetchMessages: params => dispatch(fetchMessages(params)()),
  setLastMessages: params => dispatch(setLastMessages(params)),
});

export default compose(
  withStyles(styles, { name: 'MessageListCard' }),
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true }),
)(MessageListCard);



// WEBPACK FOOTER //
// ./src/modules/messages/cards/MessageListCard/index.js